import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import React from 'react';

import { StyledSelect } from './CSelect.styles';

const CSelect = ({
  label = '',
  handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {},
  hasAnchorEl = false,
}) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const handleToggle = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setIsExpanded((prev) => !prev);
      handleClick(event);
    },
    [handleClick],
  );

  React.useEffect(() => {
    if (hasAnchorEl) return;

    setIsExpanded(false);
  }, [hasAnchorEl]);

  return (
    <StyledSelect
      variant="contained"
      color="primary"
      endIcon={<ExpandMoreIcon />}
      className={clsx({ expanded: isExpanded })}
      onClick={handleToggle}
    >
      {label}
    </StyledSelect>
  );
};

export default CSelect;
